export default __webpack_public_path__ + "static/media/ring-safari-14.8e1a59d4.png";